import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { NotificationStatus } from '@core/components/layout/notification/enums/notification-status.enum';
import { BaseResponse } from '@shared/interfaces/base-response.interface';
import { map, Observable } from 'rxjs';
import {
  NotificationRequest,
  NotificationResponse,
} from '../models/notification.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly _ofvBaseApi = environment.backendApiUrl;

  constructor(private readonly _httpClient: HttpClient) {}

  /**
   * Get all Notifications
   * @param externalId External User Id
   * @param notificationStatus If is null then get all notifications
   * @returns NotificationResponse[]
   */
  getNotifications(
    externalId: string,
    notificationStatus: NotificationStatus | undefined,
  ): Observable<NotificationResponse[]> {
    let queryParams = `idExternalUserWeb=${externalId}`;

    if (notificationStatus)
      queryParams += `&messageStatus=${notificationStatus}`;

    return this._httpClient
      .get<
        BaseResponse<NotificationResponse[]>
      >(`${this._ofvBaseApi}/v2/notification?${queryParams}`, { headers: new HttpHeaders({ lazyLoad: 'true' }) })
      .pipe(
        map((response) => {
          if (response?.data && Array.isArray(response.data)) {
            return response.data.sort(
              (a, b) =>
                new Date(b.messageDate).getTime() -
                new Date(a.messageDate).getTime(),
            );
          }
          return [];
        }),
      );
  }

  /**
   * Update the status notification.
   * @param externalId User Id
   * @param NotificationRequest
   * @returns
   */
  updateNotificationStatus(
    externalId: string,
    NotificationRequest: NotificationRequest[],
  ): Observable<BaseResponse<{ message: string }>> {
    return this._httpClient.put<BaseResponse<{ message: string }>>(
      `${this._ofvBaseApi}/v1/notification`,
      {
        idExternalUserWeb: externalId,
        typeNotification: NotificationRequest,
      },
      { headers: new HttpHeaders({ lazyLoad: 'false' }) },
    );
  }
}
